import React from 'react';
import { Grid } from '@material-ui/core';
import { Helmet } from 'react-helmet';


import './index.scss';
import { METADATA } from '../../constants';

/**Connections */
import Navbar from '../../components/Navbar';
import LiveContentTable from '../../components/LiveContentTable';

export default function UploadContent() {

  return (
    <>
      <Helmet>
        <meta name="description" content={METADATA.LIVECONTENT.description} />
        <title>{METADATA.LIVECONTENT.title}</title>
      </Helmet>
      <Navbar />
      <Grid container className="dashboard-content container" justify="center">
        <Grid
          className="dashboard-content main-menu"
          justify="center"
          xs={12}
          md={12}
          lg={12}>
            <LiveContentTable />
        </Grid>
      </Grid>
    </>
  )
}